import { ReactElement, useMemo } from "react"
import { Wrapper } from "../wrapper/wrapper"
import { TestimonialsProps } from "./testimonials-props"
import * as S from './testimonials-style'

export function Testimonials ({ id, values }: TestimonialsProps): ReactElement {
  const groups = useMemo(() => {
    const valuesClone = [...values]
    const groups = []
    while (valuesClone.length > 0) {
      groups.push(valuesClone.splice(0, 3))
    }
    return groups
  }, [values])
  return <S.Container id={id}>
    <Wrapper>
      <S.Wrapper>
        <S.Title>Depoimentos</S.Title>
        <S.CardContainer>
          <S.CarouselDesktop showThumbs={false} showArrows={false} showStatus={false}>
            {groups.map(testimonials => <S.CardWrapper>
              {testimonials.map((testimonial: any) =>
                <S.Card>
                  <p dangerouslySetInnerHTML={{ __html: testimonial.content }} />
                  <p><strong>{testimonial.author}</strong></p>
                </S.Card>)}
            </S.CardWrapper>)}
          </S.CarouselDesktop>
          <S.CarouselMobile showThumbs={false} showArrows={false} showStatus={false}>
            {values.map((testimonial: any) =>
              <S.Card>
                <p dangerouslySetInnerHTML={{ __html: testimonial.content }} />
                <p><strong>{testimonial.author}</strong></p>
              </S.Card>)}
          </S.CarouselMobile>
        </S.CardContainer>
      </S.Wrapper>
    </Wrapper>
  </S.Container>
}